import React from 'react';
import { Link } from 'react-router-dom';

export const Footer: React.FC = () => {

  return (
    <footer className="bg-gray-50 dark:bg-gray-900">
      <div className="mx-auto max-w-screen-xl px-4 py-8 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-4">
          {/* About Our Service + Logo */}
          <div>
            <div className="flex items-center mb-4">
              <Link 
                to="/"
                className="flex items-center hover:opacity-80 transition-opacity"
              >
                <img src="/logo.svg" alt="TempMail Logo" className="h-8 w-8 mr-2" />
                <span className="text-gray-700 dark:text-gray-300 font-semibold">TempMail</span>
              </Link>
            </div>
            <p className="text-gray-500 dark:text-gray-400 text-sm mt-4">
              TempMail provides secure, disposable email addresses to protect your privacy online. 
              Our service helps you avoid spam and keep your real inbox clean.
            </p>
          </div>

          {/* External Links */}
          <div>
            <p className="font-medium text-gray-900 dark:text-white">External Links</p>
            <nav className="mt-4">
              <ul className="space-y-2 text-sm">
                <li>
                  <a
                    href="https://markdown.fastbytelab.com"
                    className="text-gray-500 dark:text-gray-400 hover:text-emerald-500"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Markdown Editor
                  </a>
                </li>
                <li>
                  <a
                    href="https://x.com/FastByteLab"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-gray-500 dark:text-gray-400 hover:text-emerald-500 inline-flex items-center"
                  >
                    <svg className="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
                    </svg>
                    Follow us on X
                  </a>
                </li>
                <li>
                  <a
                    href="https://tempmail.love"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-gray-500 dark:text-gray-400 hover:text-emerald-500 inline-flex items-center"
                  >
                    <svg className="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/>
                    </svg>
                    TempMail.love
                  </a>
                </li>
              </ul>
            </nav>
          </div>
        </div>

        <div className="mt-8 border-t border-gray-100 dark:border-gray-800 pt-8">
          <p className="text-xs text-gray-500 dark:text-gray-400">
            © {new Date().getFullYear()} TempMail. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};
